import apiUtils from '@utils/apiUtils';
import { fetchAPI } from './apiServiceHelper';
import { apiConstants } from '../utils/constants';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    bmtCancellations: {
        get: ({ offset = defaultGetParam.offset, limit = defaultGetParam.limit, filter }) => {
            return fetchAPI.getList(
                `${apiConstants.BASE_URL}/api/order/report/cancellations`,
                apiUtils.normalizeQueryParams({
                    ...filter,
                    limit,
                    offset,
                })
            );
        },
    },
};

export default api;
